export const KIOSK_ROUTE = '/';
export const KIOSKNOTIF_ROUTE = '/notification';
export const confirmWithdrawalRoute = (orderNumber) => `/confirm-withdrawal/${orderNumber}`;
export const confirmWithdrawalNotificationRoute = (orderNumber) => `/confirm-withdrawal-notification/${orderNumber}`;
export const BACKOFFICE_ROUTE = '/backoffice';
export const BACKOFFICE_LOGIN_ROUTE = '/backoffice/login';
export const QUEUE_ROUTE = '/queue';
